import { ReactNode } from "react";

import CardWrapper from "./components/Wrapper";
import CardHeader from "./components/Header";
import CardContent from "./components/Content";
import { BoxProps } from "../Box";
import { TypographyProps } from "../Typography";
import { CardSize } from "./types";

type CardProps = {
  children: ReactNode;
  fullbleed?: boolean;
  variant?: "secondary" | "primary";
  size?: CardSize;
  title?: ReactNode;
  titleTag?: TypographyProps["tag"];
  className?: string;
  headerSuffix?: ReactNode;
  titleSuffix?: ReactNode;
  headerPrefix?: ReactNode;
  contentGap?: BoxProps["gap"];
  contentClassName?: string;
} & Pick<
  BoxProps,
  | "fullHeight"
  | "fullWidth"
  | "margin"
  | "padding"
  | "grow"
  | "zeroMinHeight"
  | "zeroMinWidth"
  | "overflowHidden"
>;

const Card = ({
  children,
  fullbleed,
  variant,
  size,
  title,
  className,
  contentClassName,
  headerSuffix,
  titleSuffix,
  headerPrefix,
  titleTag,
  contentGap,
  ...restBoxProps
}: CardProps) => {
  return (
    <CardWrapper variant={variant} size={size} className={className} {...restBoxProps}>
      {title && (
        <CardHeader
          titleTag={titleTag}
          prefix={headerPrefix}
          titleSuffix={titleSuffix}
          suffix={headerSuffix}
        >
          {title}
        </CardHeader>
      )}
      <CardContent
        hasHeader={!!title}
        gap={contentGap}
        fullbleed={fullbleed}
        className={contentClassName}
      >
        {children}
      </CardContent>
    </CardWrapper>
  );
};

Card.displayName = "DS.Card";

export default Card;
